import { colors } from "config/styles/themeColors";

const styles = {
  autocompleteInput: {
    width: "100%",
    "& .MuiFormControl-root": {
      backgroundColor: "background.default",
      "& .MuiFormLabel-root": {
        transform: "translate(14px, 9px) scale(1)",
      },
      "& .MuiFormLabel-root.Mui-focused": {
        color: "text.secondary",
        transform: "translate(14px, -9px) scale(0.75)",
      },
      "& .MuiFormLabel-root.MuiFormLabel-filled": {
        color: "text.secondary",
        transform: "translate(14px, -9px) scale(0.75)",
      },
      "& .MuiInputBase-root.MuiOutlinedInput-root": {
        p: "10px 16px",
      },
      "& .MuiInputBase-root.Mui-disabled": {
        backgroundColor: "background.modalBg",
      },
    },
  },
  option: {
    height: "50px",
    "&.MuiAutocomplete-option": {
      p: "8px 12px",
      minHeight: "fit-content",
    },
    "&.MuiAutocomplete-option.Mui-focused": {
      backgroundColor: "background.hover",
    },
    "&.MuiAutocomplete-option[aria-selected='true'].Mui-focused": {
      backgroundColor: "background.hover",
    },
    "&.MuiAutocomplete-option[aria-selected='true']": {
      backgroundColor: "background.hover",
    },
    "&.MuiAutocomplete-option[aria-selected='true'] > p": {
      fontWeight: 700,
    },
  },
  visibleIcon: {
    cursor: "pointer",
    fill: colors.text.secondary,
  },
};

export default styles;
